/**
 * 便民服务
 */
import React from 'react';
import UserList from "../userManage/UserList";
import $ from "jquery";
import ConvenienceServeAdd from "./ConvenienceServeAdd";
import {Button, Modal} from "antd";
import {formatDate} from "../../../utils";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils";
import ServeSort from "./ServeSort";

export default class ConvenienceServeList extends UserList {

    getListData() {
        let params = {
            start: this.state.offsite,
            size: this.state.count,
            ...this.state.screenObj
        }
        this.request({
            url: "/cm-sites-mmp/homepageUrl/list",
            method: "get",
            body: params,
            callBack: (res) => {
                let listData = [];
                let hideOnSinglePage = true;
                let total = 0;
                if (res && res.data && res.data.length) {
                    listData = res.data;
                    total = res.count;
                    hideOnSinglePage = false;
                }
                this.setState({
                    listData,
                    total,
                    hideOnSinglePage
                }, () => {
                    $('.ant-pagination-options-quick-jumper').find("input").val("");
                })
            }
        });
    }

    getScreenList() {
        return (
            [
                {
                    key: "urlName",
                    field: "urlName",
                    placeholder: "请输入服务名称",
                    type: "1",
                }
            ]
        )
    }

    getColumns() {
        return (
            [
                {
                    title: "服务名称",
                    key: 'urlName',
                    dataIndex: 'urlName',
                    ellipsis: true,
                },
                {
                    title: "服务图片",
                    key: 'urlPic',
                    dataIndex: 'urlPic',
                    ellipsis: true,
                    render: (text, record) => {
                        return (
                            <div><img style={{width: "40px", height: "40px", objectFit: "cover"}}
                                      src={text} alt={""}/></div>
                        )
                    }
                },
                {
                    title: "服务地址",
                    key: 'urlAddress',
                    dataIndex: 'urlAddress',
                    ellipsis: true,
                },
                {
                    title: "状态",
                    key: 'urlStatus',
                    dataIndex: 'urlStatus',
                    ellipsis: true,
                    render: (text, record) => {
                        let urlStatus;
                        switch (text) {
                            case "1":
                                urlStatus = "启用";
                                break;
                            case "2":
                                urlStatus = "禁用";
                                break;
                            default:
                                urlStatus = "";
                        }
                        return (
                            <div>{urlStatus}</div>
                        )
                    }
                },
                {
                    title: "更新时间",
                    key: 'updateTime',
                    dataIndex: 'updateTime',
                    ellipsis: true,
                    width: 180,
                    render: (text, record) => {
                        return (
                            <div style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}>{text ? formatDate(text) : ""}</div>
                        )
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 100,
                    render: (text, record) => {
                        return (
                            <div>
                            <span style={{color: "#0050B3", cursor: "pointer", marginRight: 10}}
                                  onClick={() => this.convenienceServeAdd.show(record)}>编辑</span>
                                <span style={{color: "#0050B3", cursor: "pointer"}}
                                      onClick={() => this.delete(record)}>删除</span>
                            </div>
                        )
                    }
                }
            ]
        )
    }

    delete(record) {
        Modal.confirm({
            title: "确认删除该服务？",
            onOk: () => {
                this.request({
                    url: "/cm-sites-mmp/homepageUrl/delete",
                    body: {id: record.id},
                    method: "get",
                    callBack: (res) => {
                        if (res) {
                            message.success("删除成功");
                            if (this.state.listData.length === 1 && this.state.offsite > 1) {
                                this.paginationOnChange(this.state.offsite - 1, this.state.count)
                            } else {
                                this.paginationOnChange(this.state.offsite, this.state.count)
                            }
                        }
                    }
                });
            }
        })
    }

    renderAddModal() {
        return (
            <ConvenienceServeAdd ref={(convenienceServeAdd) => this.convenienceServeAdd = convenienceServeAdd}
                                 refreshList={() => {
                                     this.getListData();
                                 }}/>
        )
    }

    renderBtn() {
        return (
            <div style={{marginTop: 20}}>
                <Button style={{marginRight: "20px"}} onClick={() => {
                    this.convenienceServeAdd.show();
                }} type={"primary"}>
                    新增服务
                </Button>
                <Button style={{marginRight: "20px"}} onClick={() => {
                    if(!this.state.listData.length) {
                        message.warn("暂无数据！");
                        return;
                    }
                    this.dragSort.showSortModal();
                }}>
                    服务排序
                </Button>
                <ServeSort title={"服务排序"} ref={ref => this.dragSort = ref} refreshList={() => this.getListData()}/>
            </div>
        )
    }
}